var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZone1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1154.186 2061",
    style: {
      enableBackground: "new 0 0 1154.186 2061"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "zone_1"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FA553A",
      strokeWidth: 46.6112,
      strokeMiterlimit: 10
    },
    x1: 493.863,
    y1: 1621.572,
    x2: 0,
    y2: 1621.572
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FA553A",
      strokeWidth: 46.6112,
      strokeMiterlimit: 10
    },
    d: "M1148.748,1787.547H574.553 c-38.46,0-69.639-31.178-69.639-69.639v-494.505c0-38.652-31.333-69.985-69.985-69.985H0"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FA553A",
      strokeWidth: 46.6112,
      strokeMiterlimit: 10
    },
    x1: 491.144,
    y1: 1282.474,
    x2: 1154.186,
    y2: 1282.474
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.618,
    y: -0.594,
    style: {
      fill: "none"
    },
    width: 1147.411,
    height: 2061
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000041982824193249335540000016065724317660084411_"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZone1);
export default __webpack_public_path__ + "static/media/zone_1.c952aa87.svg";
export { ForwardRef as ReactComponent };